import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Box, Indicator, Portal } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';

import { Icon } from '@flecto/ui';

import styles from './styles.module.css';

export type FormImagesProps = {
  images: string[]
}

export function FormImages({ images = [] }: FormImagesProps) {
  const ref = useClickOutside(() => setSelected(''))
  const [selected, setSelected] = useState('')

  const handleOpenImage = (img: string) => {
    setSelected(img)
  }

  return (
    <Box className={styles.imgs}>
      {images.map((image, key) => (
        <Image
          key={key}
          src={image}
          alt='Doc'
          onClick={() => handleOpenImage(image)}
        />
      ))}
      <Portal>
        <Box
          className={clsx(styles.imgSelected, {
            [styles.imgSelectedOpen]: selected,
          })}
        >
          <Indicator
            label={<Icon icon={faTimes} />}
            color='red'
            size={24}
            onClick={() => setSelected('')}
            style={{ cursor: 'pointer' }}
          >
            <Image src={selected} alt='Doc' ref={ref} />
          </Indicator>
        </Box>
      </Portal>
    </Box>
  )
}
